import { useContext, useEffect, useState, useRef } from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import AuthContext from '../contexts/AuthContext';
import Iframe from 'react-iframe';
import ContentById from '../graphql/queries/contentbyId';
import { useMultiState } from '../lib/hooks';
import { useQuery, useMutation } from '@apollo/client';
import { useParams } from 'react-router';
import axios from 'axios';

import progressbyId from '../graphql/queries/progressbyId';
import ProgressMutation from '../graphql/mutations/updateProgress';
import CloudflareVideoPlayer from '../components/pages/videoPlayerPage/clondflareVideoPlayer';

require('dayjs/locale/th');
require('dayjs/locale/en');

var localizedFormat = require('dayjs/plugin/localizedFormat');
dayjs.extend(localizedFormat);

const STATUS = {
  STARTED: 'Started',
  STOPPED: 'Stopped',
};

const URL_VIDEO = process.env.REACT_APP_URL_CLOUDFLARE;
const VideoPlayerPage = () => {
  const { user } = useContext(AuthContext);

  const param = useParams();

  const { data: Content } = useQuery(ContentById, {
    variables: {
      _id: param?.contentId,
    },
  });

  const { data: userprogress } = useQuery(progressbyId, {
    variables: {
      content: param?.contentId,
      student: user?._id,
    },
  });

  const progressId = userprogress?.progress?._id || null;
  const initialWatchedRanges = userprogress?.progress?.watchedRanges || [];
  const lastWatched = userprogress?.progress?.lastWatched || 0;
  const videoLength = Content?.content?.duration || 0;
  const videoUrl = Content?.content?.link || '';

  return (
    <Box w={'100%'} mt={10}>
      <Box px={[2, 2, 10, 20]}>
        <CloudflareVideoPlayer
          videoUrl={videoUrl}
          videoLength={videoLength}
          progressId={progressId}
          initialWatchedRanges={initialWatchedRanges}
          lastWatched={lastWatched}
        />{' '}
        <Heading py={'4'}>{Content?.content?.name}</Heading>
        <Text p={'2'}>{Content?.content?.carddescription}</Text>
      </Box>

      {/* <Text>
                {progressState?.activetime}{`TRACK ${tracking % 10} `}
            </Text> */}
    </Box>
  );
};

export default VideoPlayerPage;
